/**
 * AI 콘텐츠 초안 진입점(플로팅)을 노출할 상품상세 진입 출처(FROM) 목록.
 *
 * '온보딩 미션, 추천 리워드 상품' 진입점을 통해 상세페이지에 진입한 경우에만
 * 진입점을 노출한다. 그 외 경로로 진입하면 노출하지 않는다.
 *
 * - AFFILIATE_HOME: 온보딩 미션(어필리에이트 홈) 진입점
 * - AFFILIATE_RECOMMEND_REWARD_GOODS: 추천 리워드 상품 진입점
 */
export const AI_CONTENT_DRAFT_ENTRY_FROM_SCREENS = [
  'AFFILIATE_HOME',
  'AFFILIATE_RECOMMEND_REWARD_GOODS',
] as const;
